import React, {useEffect, useState} from "react";
import "../styles/campaignlayout.scss";
import SupportCard from "../../../ui/supportcard/supportcard";
import DesktopStepper from "../../../ui/stepper/desktop/desktopstepper";
import MatchingCampaign from "../../../pages/components/matchingcampaign";
import {Banner} from "../../../modals/types/banner";
import MobileStepper from "../../../ui/stepper/mobile/mobileStepper";
import BannerAds from "../../../pages/components/bannerads";
import GoogleAds from "../../../pages/components/googleads";
import VideoAds from "../../../pages/components/videoads";
import ProductAds from "../../../pages/components/productads";
import InstagramViewPost from "../../../pages/components/social-media/instagram/view/post/instagramviewpost";
import InstagramViewStory from "../../../pages/components/social-media/instagram/view/story/instagramviewstory";
import InstagramPricingPostContent
    from "../../../pages/components/social-media/instagram/pricing/post/instagrampricingpostcontent";
import InstagramPricingPostInfluencer
    from "../../../pages/components/social-media/instagram/pricing/post/instagrampricingpostinfluencer";
import TelegramPostCreate from "../../../pages/components/social-media/telegram/post/telegrampostcreate";
import TelegramPostForward from "../../../pages/components/social-media/telegram/post/telegrampostforward";
import ProvincialTeaser from "../../../pages/components/social-media/provincialteaser/provincialteaser";

interface ICampaignLayout {
    id: number;
}

const CampaignLayout = ({id}: ICampaignLayout) => {

    const [elements, setElements] = useState([<></>]);
    const [image, setImage] = useState("");
    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");

    useEffect(() => {
        document.body.style.backgroundColor = "#fff";
        if (id === 0) {
            setElements(MatchingCampaign);
        } else if (id === 1) {
            setElements(BannerAds);
        } /*else if (id === 2) {
            setElements(BannerAds);
        }*/ else if (id === 3) {
            setElements(GoogleAds);
        } else if (id === 4) {
            setElements(VideoAds);
        } else if (id === 5) {
            setElements(ProductAds);
        } else if (id === 6) {
            setElements(InstagramViewPost);
        } else if (id === 7) {
            setElements(InstagramViewStory);
        } else if (id === 8) {
            setElements(InstagramPricingPostContent);
        } else if (id === 9) {
            setElements(InstagramPricingPostInfluencer);
        } else if (id === 10) {
            setElements(TelegramPostCreate);
        } else if (id === 11) {
            setElements(TelegramPostForward);
        } else if (id === 12) {
            setElements(ProvincialTeaser);
        }
    }, []);

    const sideElements: Banner[] = [
        {
            image: require("../../../assets/images/banners/CampaignGoal.svg").default,
            title: "هدف شما از ارائه تبليغات چیست؟",
            body: "در تی‌جار برای راحتی و گرفتن نتیجه بهتر، می‌توانید هدف تبلیغاتی کسب‌وکار خود انتخاب و به صورت هوشمند رسانه‌ها به شما پیشنهاد داده خواهد شد." +
                "همچنین انتخاب رسانه به صورت دلخواه در مود‌ حرفه‌ای امکان پذیر است."
        },
        {
            image: require("../../../assets/images/banners/CampaignMoney.png"),
            title: "بودجه  و اطلاعات خود را تعیین کنید",
            body: "در این قسمت و به منظور ارائه پیشنهاد هوشمند برخی از اطلاعات کسب‌وکار شما و بودجه کلی که برای تبلیغات در نظر گرفته‌اید را تایین نمایید."
        }, {
            image: require("../../../assets/images/banners/CampaignMedia&Proposal.png"),
            title: "رسانه های پیشنهادی تیجار",
            body: "این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند"
        }, {
            image: require("../../../assets/images/banners/CampaignMedia&Proposal.png"),
            title: "اطلاعات رسانه ها را تکمیل کنید",
            body: "در هر بخش جزییات و تنظیمات خواسته شده برای رسانه‌ها را تکمیل کرده تا بهترین نتیجه حاصل شود. نوع تبلیغی که نمایش داده می‌شود، زمانبندی و سایر تنظیمات در این بخش انتخاب می‌شود."
        },
        {
            image: require("../../../assets/images/banners/CampaignMoney.png"),
            title: "تایید نهایی پرداخت هزینه تبلیغات",
            body: "در این بخش اطلاعات وارد شده کمپین را تایید و  هزینه تبلیغات پرداخت نمایید." +
                "پس از تایید توسط کارشناسان تی‌جار کمپین شما شروع به کار خواهد کرد."
        },
    ]

    return (
        <div className="Campaign-Layout">
            <div className="container mt-3">
                <img style={{width: "130px"}} src={require("../../../assets/images/Logo2.png")} alt=""
                     className="img-fluid"/>
            </div>
            <div className="container-fluid mt-3">
                <div className="row flex-lg-row flex-md-column-reverse flex-column-reverse">
                    <div className="col-lg-4 col-12 mb-3">
                        <div className="Side-Section">
                            <div
                                className="d-flex flex-column justify-content-center align-items-center Side-Section-Top">
                                <img src={image} alt="bannerImage" className="img-fluid"/>
                                <h4 className="text-center">{title}</h4>
                                <p className="text-center">{body}</p>
                            </div>
                            <SupportCard/>
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 mb-3">
                        <div className="Main-Section">
                            <div className="container">
                                <DesktopStepper elements={elements} sideElements={sideElements} setImage={setImage}
                                                setTitle={setTitle} setBody={setBody}/>
                            </div>
                            <div className="container-fluid">
                                <MobileStepper elements={elements} sideElements={sideElements} setImage={setImage}
                                               setTitle={setTitle} setBody={setBody}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CampaignLayout;